export const ROOT = '/';
export const MAIN = '/main';
export const STATIC = '/static';
